// import React from 'react';
import { styled } from '@mui/material/styles';
import { EuTaxonomyClobDto, AffinityDto } from 'models/dtoTypes';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import SubSection from './_subSection';
import Empty from './_empty';
import { taxonomySvg } from 'kosmos/images';
import EsgLegand from './_esgLegand';
import { ISdgData } from './_sdgScoreClob';
import EuOptionSlider from './_euOptionSlider';

const ItemRoot = styled('div')(() => ({
  position: 'relative',
  maxWidth: 900,
  lineHeight: 2,
  marginBottom: 15,
}));


interface IProps {
  name?: string;
  euTaxonomyReport: EuTaxonomyClobDto[];
}

export default function DoNoSignificantHarmReport(props: IProps): JSX.Element {
  const {
    name = 'EU Taxonomy score',
    euTaxonomyReport
  } = props;

  const getOption = (affinity?: AffinityDto): number => {
    switch (affinity) {
      case 'unscored': return -1;
      case 'negative': return 0;
      case 'warning': return 1;
      case 'neutral': return 2;
      case 'positive': return 3;
      default: return -1;
    }
  };

  const renderSingleListItem = (item: EuTaxonomyClobDto, index: number) => {
    const { title, affinity } = item;
    const option = getOption(affinity);
    return (
      <ItemRoot key={index}>
        <EuOptionSlider title={title || ''} option={option} />
      </ItemRoot>
    );
  };

  const renderLegands = () => {
    const legands: ISdgData[] = [
      {
        affinity: 'negative',
        title: 'Activity found to cause significant harm against corresponding EU Taxonomy Regulation.',
        size: 'small',
      },
      {
        affinity: 'warning',
        title: 'Activity found to cause significant harm against corresponding EU Taxonomy Regulation, but there is an opportunity for improvement.',
        size: 'small',
      },
      {
        affinity: 'positive',
        title: 'Activity found to positively contribute to corresponding EU Taxonomy Regulation.',
        size: 'small',
      },
      {
        affinity: 'neutral',
        title: 'No significant harm found against corresponding EU Taxonomy Regulation.',
        size: 'small',
      },
    ];

    return (
      <EsgLegand
        legands={legands}
        title="Activity check against EU Taxonomy Regulation. "
        learnMoreTabId="eu"
      />
    );
  };
  const renderAllListItems = () => {
    return (
      <Box
        sx={{
          width: '100%',
          bgcolor: 'background.paper',
        }}
      >
        <Stack direction="column" spacing={6}>
          {euTaxonomyReport.map(renderSingleListItem)}
        </Stack>
      </Box>
    );
  };
  const renderContent = () => {
    if (euTaxonomyReport.length === 0) {
      return <Empty title="There is no data available"/>;
    }

    return renderAllListItems();
  };

  return (
    <SubSection
      title={name}
      icon={<img src={taxonomySvg} />}
    >
      <>
        {renderLegands()}
        {renderContent()}
        <p>* Please note that the full EU Taxonomy Regulation is still to be agreed by the EU. Some industries are not yet covered by EU Taxonomy Regulation. In such cases activity is marked as &quot;No Significant Harm&quot;. EU Taxonomy Regulation scores offer an indicator based on the best available data. </p>
      </>
    </SubSection>
  );
}

